// extracted by mini-css-extract-plugin
export default {"more":"styles_more__r3-zC","icon":"styles_icon__NgvQH"};